import React from 'react';
import RegisterStep1 from './ui/RegistrationStep1';
import RegisterStep2 from './ui/RegistrationStep2';
import { motion } from 'framer-motion';
import { RegisterStep, useRegisterScreenViewModel } from './RegisterScreenViewModel';
import { HeaderBar } from '@/components/ui';
import { UI_STYLES } from '@/styles/uiStyles';
import { Helmet } from 'react-helmet-async';


export const RegisterScreen: React.FC = () => {

  const {
    name,
    nameError,
    email,
    birthDate,
    birthDateError,
    password,
    passwordVisible,
    confirmPassword,
    confirmPasswordVisible,
    emailError,
    passwordError,
    confirmPasswordError,
    step,
    error,
    setEmail,
    setPassword,
    setConfirmPassword,
    togglePasswordVisibility,
    toggleConfirmPasswordVisibility ,
    setName,
    setBirthDate,
    setStep,
    handleSubmitStep1,
    handleSubmitStep2,
    navigateToLogin,
  } = useRegisterScreenViewModel();

  return (
    <div className={`flex-1 flex flex-col ${UI_STYLES.backgroundDarkBlue} h-full` }>
      <Helmet>
        <title>Регистрация в астрологическом приложении | Мир Звёзд</title>
        <meta name="description" content="Создайте аккаунт в приложении Мир Звёзд и получите доступ к персональным астрологическим прогнозам, картам Таро дня и чату с профессиональным астрологом. Быстрая и безопасная регистрация." />
        <meta name="keywords" content="регистрация, создать аккаунт, астрология, астрологическое приложение, личный кабинет, зарегистрироваться, астрологические услуги" />
        <meta name="author" content="bpTech" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Регистрация в астрологическом приложении | Мир Звёзд" />
        <meta property="og:description" content="Создайте аккаунт в приложении Мир Звёзд и получите доступ к персональным астрологическим прогнозам и картам Таро дня." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://мир-звезд.рф/register" />
      </Helmet>
      <div className="flex flex-col items-center flex-1 px-4 pb-6 w-full max-w-md mx-auto mt-2 ">
      <HeaderBar title="Регистрация" onBack={ step === RegisterStep.Step2 ? () => setStep(RegisterStep.Step1) : undefined} />
    <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 0.3, ease: "easeInOut" }}
    className="h-full"
  >
      {step === RegisterStep.Step1 && (
        <RegisterStep1
          onSubmit={handleSubmitStep1}
          onLoginClick={navigateToLogin}
          name={name}
          birthDate={birthDate}
          nameError={nameError}
          birthDateError={birthDateError}
          setName={setName}
          setBirthDate={setBirthDate}
        />
      )}
      {step === RegisterStep.Step2 && (
        <RegisterStep2
          onSubmit={handleSubmitStep2}
          onLoginClick={navigateToLogin}
          email={email}
          firstPassword={password}
          secondPassword={confirmPassword}
          firstPasswordVisible={passwordVisible}
          secondPasswordVisible={confirmPasswordVisible}
          setEmail={setEmail}
          setFirstPassword={setPassword}
          setSecondPassword={setConfirmPassword}
          setFirstPasswordVisible={togglePasswordVisibility}
          setSecondPasswordVisible={toggleConfirmPasswordVisibility}
          emailError={emailError}
          firstPasswordError={passwordError}
          secondPasswordError={confirmPasswordError}
          error={error}
        />
      )}
    </motion.div>
    </div>
    </div>
  );
};

export default RegisterScreen; 
